<template>
    <div class="main-container">
        <h3>Release Compensation for ESS</h3>
        <div>
          <div  class="option-container">
            <div class="content-width">
              <div class="download-btn-container">
                <img src="@/assets/download.svg"  class="img" />
                <a class="text" href="https://payliefprod-client-logos.s3.ap-south-1.amazonaws.com/templates/bulkApprovalTemplate.xlsx">Download Template</a>
              </div>
              <upload :key="componentKey" :tobucket="false" @change="onUploadTemplate($event)"></upload>
            </div>
          </div>
        </div>
        <pop-up-message
          v-if="showErrorPopup"
          :message="showMessage"
          btnText="OK"
          @back="gotoBack()"
        ></pop-up-message>
        <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
const crypto = require("crypto");
export default {
  data(){
    return{
      employeeLopData:[],
      toast:false,
      errmsg:'',
      paymentYear: '',
      paymentMonth: '',
      documentType: null,
      excel_file: '',
      zip_file: '',
      fileTypeEnums: {
        paySlip: "Payslip",
        ITSheet: "IT sheet"
      },
      showErrorPopup: false,
      logSheetUrl: null,
      uploadDataDetails: [],
      showMessage: '',
      componentKey: 0
    }
  },
  mounted(){
    
  },
  activated(){
    
  },
  computed: {
    ...mapState({
      entities: state => state.onboard.legal_entities.data
    }),

    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods:{
    ...mapActions({
      act_update_ctc_status: "dashboard/organisation/utilities/itsheetandpayslip/updateCtcReportStatus",
      act_get_upload_logs: "dashboard/organisation/utilities/itsheetandpayslip/getUploadPreviousPayslipItsheetLogs",
      act_get_upload_logs_presigned_url: "dashboard/organisation/utilities/itsheetandpayslip/getLogsPresignedUrl"
    }),

    gotoBack(){
      this.showErrorPopup = false;
      // this.getUploadPyaslipsLogs();
    },

    async onUploadTemplate(event){
      try {
        let formData = new FormData();
        formData.append("approve", event);
        formData.append("legalEntityId", this.le_id);
        let result = await this.act_update_ctc_status(formData);
        let decryptResult = await this.decrypt(result.data)
        decryptResult = JSON.parse(decryptResult)
        if(decryptResult && decryptResult.success){
          console.log(decryptResult);
          this.showErrorPopup = true;
          this.showMessage = decryptResult.message;
          this.componentKey += 1;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err
      }
    },

    async decrypt(payload) {
      try {
          const key = process.env.VUE_APP_PAYSLIP_SECRET;
          const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
          const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
          return decrypted.toString();
      } catch (error) {
          // console.log(error)
      }
    },
  }
  
}
</script>

<style scoped lang="scss">
  .option-container{
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    margin-top: 20px;
  }

.customButton{
  display: block;
  border-radius: 4px;
  background-color: #5d409f;
  color: #ffffff;
  font-weight: bold;
  width:18%;
  min-height: 45px;
  padding: 14px;
  transition: all 0.5s ease;
}

.customButton:hover{
  opacity: 0.8;
}

.content-width{
  min-width: 20%;
}

.table-container{
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: end;
}

.refresh{
  background-color: #5d409f;
  color: #ffffff;
  font-weight: 500;
  border-radius: 4px;
  padding: 8px 18px;
  margin-bottom: 10px;
  transition: all 0.5s ease;
}

.refresh:hover{
  opacity: 0.8;
}

.download-icon{
  display: flex; 
  align-items: center; 
  gap: 10px; 
  cursor: pointer;
}
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    margin-left: 8px;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
</style>
